// react
import React, { useState } from "react";

// third-party
import { connect } from "react-redux";

// application
import Indicator from "./Indicator";
import Menu from "./Menu";
import { Check12x9Svg, Globe20Svg } from "../../svg";
import { localeChange } from "../../store/locale";
import { languages } from "../../data/generalData";

function IndicatorLanguage(props) {
    const { locale, localeChange: changeLocale } = props;
    const [closeIndicator, setCloseIndicator] = useState(false);

    const currentLanguage = languages.find((item) => item.locale === locale);

    const handleSelect = (item) => {
        changeLocale(item.locale);
        setCloseIndicator(true);
        setTimeout(() => setCloseIndicator(false), 500);
    };

    const menuItems = languages.map((item) => ({
        ...item,
        name: (
            <React.Fragment>
                {item.title}
                {item.locale === locale && <Check12x9Svg className="menu__check" />}
            </React.Fragment>
        ),
    }));

    const dropdown = (
        <div className="language-menu">
            <Menu withIcons items={menuItems} onClick={handleSelect} />
        </div>
    );

    return (
        <Indicator
            className="notranslate"
            closeIndicator={closeIndicator}
            dropdown={dropdown}
            value={currentLanguage?.code}
            icon={<Globe20Svg />}
        />
    );
}

const mapStateToProps = (state) => ({
    locale: state.locale,
});

const mapDispatchToProps = {
    localeChange,
};

export default connect(mapStateToProps, mapDispatchToProps)(IndicatorLanguage);
